import React from 'react';

const BackArrow: React.FC = () => {
  return (
    <svg
      className="h-3 w-3 inline-block mx-2"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <polygon
        id="arrow"
        points="3.82842712 9 9.89949494 2.92893219 8.48528137 1.51471863 0 10 0.707106781 10.7071068 8.48528137 18.4852814 9.89949494 17.0710678 3.82842712 11 20 11 20 9 3.82842712 9"
      />
    </svg>
  );
};

export default BackArrow;
